var _rect, _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCotent(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 28,
    viewBox: "0 0 30 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 28,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.4628 10.2762H22.8953V4.48558C22.8953 3.11988 21.7754 2 20.4097 2H4.48558C3.11988 2 2 3.11988 2 4.48558V22.9772C2 24.3429 3.11988 25.4628 4.48558 25.4628H24.3976C26.3642 25.4628 27.9484 23.8786 27.9484 21.912V12.7618C27.9484 11.3961 26.8285 10.2762 25.4628 10.2762ZM4.48558 23.4416C4.23976 23.4416 4.04856 23.2504 4.04856 23.0046V4.48558C4.04856 4.23976 4.23976 4.04856 4.48558 4.04856H20.4097C20.6555 4.04856 20.8467 4.23976 20.8467 4.48558V21.9393C20.8467 22.4856 20.956 22.9772 21.1745 23.4416H4.48558ZM24.3976 23.4416C25.217 23.4416 25.8998 22.7587 25.8998 21.9393V12.7618C25.8998 12.5159 25.7087 12.3247 25.4628 12.3247H22.8953V21.9393C22.8953 22.7587 23.5781 23.4416 24.3976 23.4416Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.21685 12.6525H10.1941C10.7677 12.6525 11.2047 12.1882 11.2047 11.6419V7.40821C11.2047 6.83461 10.7404 6.39758 10.1941 6.39758H7.21685C6.64325 6.39758 6.20622 6.86192 6.20622 7.40821V11.6146C6.17891 12.1882 6.64325 12.6525 7.21685 12.6525Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.678 14.8376H7.21668C6.64308 14.8376 6.20605 15.302 6.20605 15.8483C6.20605 16.3946 6.67039 16.8589 7.21668 16.8589H17.678C18.2516 16.8589 18.6886 16.3946 18.6886 15.8483C18.6886 15.302 18.2516 14.8376 17.678 14.8376Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6785 10.6039H14.0184C13.4448 10.6039 13.0078 11.0683 13.0078 11.6146C13.0078 12.1608 13.4722 12.6252 14.0184 12.6252H17.6785C18.2521 12.6252 18.6891 12.1608 18.6891 11.6146C18.6891 11.0683 18.2521 10.6039 17.6785 10.6039Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6785 6.39758H14.0184C13.4448 6.39758 13.0078 6.86192 13.0078 7.40821C13.0078 7.95449 13.4722 8.41883 14.0184 8.41883H17.6785C18.2521 8.41883 18.6891 7.95449 18.6891 7.40821C18.6891 6.86192 18.2521 6.39758 17.6785 6.39758Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.678 19.044H7.21668C6.64308 19.044 6.20605 19.5083 6.20605 20.0546C6.20605 20.6282 6.67039 21.0653 7.21668 21.0653H17.678C18.2516 21.0653 18.6886 20.6009 18.6886 20.0546C18.6886 19.5083 18.2516 19.044 17.678 19.044Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCotent);
export default __webpack_public_path__ + "static/media/cotent.77966109.svg";
export { ForwardRef as ReactComponent };